// ----------------------------------------------------------------------

export default function Button(theme) {
    return {
        MuiToggleButton: {
            styleOverrides: {
                root: {
                    "&:hover": {
                        boxShadow: "none",
                        backgroundColor: "transparent",
                    },
                    "&.Mui-selected": {
                        "&:hover": {
                            boxShadow: "none",
                            backgroundColor: "rgba(13, 110, 253, 0.08)",
                        },
                    },
                },
            },
        },
    };
}
